import { TimetableSidePanel } from "@src/components/web/TimetableSidePanel.web";
import { WebLayout } from "@src/components/web/WebLayout.web";
import { Slot, Stack, useLocalSearchParams } from "expo-router";

export default function AlarmRoutesWebLayout() {
  const params = useLocalSearchParams<{ siteId?: string; cameraKey?: string }>();
  const siteId = params.siteId;
  const cameraKey = params.cameraKey;

  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <WebLayout rightPanel={cameraKey && siteId ? <TimetableSidePanel cameraKey={cameraKey} siteId={siteId} /> : null}>
        <Slot />
      </WebLayout>
    </>
  );
}
